import { useLoggedInUser } from '@wac-web/utils/logged-in-user-provider';

import { Stack } from '@atlaskit/primitives-next';

import { CustomerNameAndLogoHeader } from '@/common/customer-name-and-logo-header';
import { useRoutes, useUserInfo } from '@/common/hooks';
import { LegalBanner } from '@/common/legal-footer/src/legal-banner';
import { RelationshipSection } from '@/common/relationships';
import { getCurrentTime } from '@/common/utils';
import { CustomerWelcomeBanner } from '@/common/welcome-banner';

import { useDashboardPageAnalytics } from './hooks';
import { MigrationTicketsList } from './migration-tickets-list';
import { RollupStatusSection } from './rollup-status-section';
import { SummarySection } from './summary-section';

export const FastshiftDashboard = () => {
	const { data: user } = useUserInfo();
	const hasMoveTicketAccess = user?.hasMoveTicketAccess === true;

	const { paths } = useRoutes();

	const userInfo = useLoggedInUser();
	const currentTime = getCurrentTime();

	useDashboardPageAnalytics();

	return (
		<Stack space="space.300">
			{user?.userType === 'CUSTOMER' && (
				<Stack space="space.300">
					<CustomerWelcomeBanner currentTime={currentTime} userName={userInfo?.name} />
					<LegalBanner />
				</Stack>
			)}
			{user?.userType !== 'CUSTOMER' && <CustomerNameAndLogoHeader />}
			{hasMoveTicketAccess && (
				<Stack space="space.400">
					<RollupStatusSection />
					<SummarySection />
					<MigrationTicketsList migrationTicketsUrl={paths.domainScopedTickets} />
					<RelationshipSection />
				</Stack>
			)}
		</Stack>
	);
};
